/*
 * @Author: 晾衣架 1308251352@qq.com
 * @Date: 2023-07-27 10:02:48
 * @LastEditors: 晾衣架 1308251352@qq.com
 * @LastEditTime: 2023-07-31 00:49:19
 * @FilePath: /m-terminal-PC/src/enums/pageEnum.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export enum PageEnum {
  // 投资意向书-机构
  QUESTIONNAIRE = '/questionnaire',
  // 投资意向书-个人
  QUESTIONNAIRE_IPI = '/questionnaire-ipi',
  QUESTIONNAIRE_CPI = '/questionnaire-cpi',
  // 投资意向书-信息介绍
  QUESTIONNAIRE_INFO = '/information',
  // 禁止访问页面
  FORBIDDEN_PAGE = '/403',
  /**
   * 游客首页
   */
  HOME = '/home',
  // basic login path
  BASE_LOGIN = '/login',
  // basic home path
  BASE_HOME = '/dashboard',
  // 系统维护页面
  SYS_UPDATE = '/sys_update',
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list',
  // 注册会员
  ACCOUNT_AGREEMENT = '/account/agreement',
  ACCOUNT_PITYPESELECT = '/account/piTypeSelect',
  ACCOUNT_SUBTYPESELECT = '/account/subTypeSelect',
  ACCOUNT_REGISTER = '/account/register',
  // 个人Pi页面
  INDIVIDUAL_PI = '/account/individual',
  INDIVIDUAL_PI_APPLY = '/account/individual/apply',
  // 企业Pi页面
  CORPORATE_PI = '/account/corporate',
  // 机构Pi页面
  INSTITUTION_PI = '/account/institution',
  INSTITUTION_PI_APPLY = '/account/institution/apply',

  // 交易首页
  TRANSACTION = '/transactions/transaction',

  // 交易所有DRO
  TRANSACTION_ALL_DRO = '/transactions/allDro',

  // 交易申购
  TRANSACTION_BUYING = '/transactions/transaction/buy',

  // 交易DRO详情
  TRANSACTION_DRO_DETAIL = '/transactions/transaction/dro_detail',

  // 自选页面
  OPTIONAL = '/optionals/optional',

  // 自选申购
  BUYING = '/optionals/optional/buy',

  // etp转让
  ETPTRANS = '/holdings/holding/transfer_etp',

  // 自选DRO详情
  OPTIONAL_DRO_DETAIL = '/optionals/optional/detail',
  // 自选ETP详情
  OPTIONAL_ETP_DETAIL = '/optionals/optional/detail_etp',

  // 持仓页面
  HOLDING = '/holdings/holding',

  // 持仓转让
  TRANSFER = '/holdings/holding/transfer',

  // 收益分配
  INCOME_DISTRIBUTION = '/holdings/holding/income/',

  // 收益分配明细
  INCOME_DISTRIBUTION_DETAIL = '/holdings/holding/income-detail/',

  // 持仓ETP详情
  HOLDING_ETP_DETAIL = '/holdings/holding/detail_etp',

  // 用户权限管理
  MEMBER_ROLES = '/member/roles',

  // DRO详情
  DRO_DETAIL = '/transactions/transaction/detail',
  // ETP详情
  ETP_DETAIL = '/transactions/transaction/detail_etp',

  // 账户管理
  MEMBER_ACCOUNT_MANAGEMENT = '/member/account_management',
  // 用户信息
  MEMBER_INFO = '/member/memberInfo',
  MEMBER_INFO_VIEW = '/member/memberInfoView',
  UPDATE_MEMBER_INFO = '/member/updateMemberInfo',

  // 资金
  FINANCE = '/finances/finance',
  // 交易资金分配
  FINANCE_ALLOCATION = '/finances/finance/allocation',
  // 交易资金分配记录
  ALLOCATION_DETAIL = '/finances/finance/detail',

  // 委托
  ENTRUST = '/entrusts/entrust',
  // 委托交易详情
  ENTRUST_DETAIL = '/entrusts/detail',

  USER_INFO = '/user/index',

  // 结算单列表
  SETTLE_LIST = '/settle/list',

  /**
   * dpm页面
   */
  DPM = '/dpm',
  /**
   * DMP-持仓列表
   */
  DMP_HOLDING = '/dmp/holding',
  /**
   * DMP-DRO详情
   */
  DMP_HOLDING_DETAIL = '/dmp/holding/detail_dro',

  // 市场总览组合试算
  MARKET = '/market',
  MARKET_INDEX = '/market/index',
  MARKET_PACKAGE_ASSEMBLY = '/market/packageAssembly',
  MARKET_PACKAGE_ASSEMBLY_DETAIL = '/market/packageAssemblyDetail',
  MARKET_DRO_DETAIL = '/market/droDetail',
  MARKET_ALL_MARKET = '/market/allMarket',
  MARKET_ALL_DRO = '/market/allDro',
  MARKET_ALL_BRAND = '/market/allBrand',

  // 已登录时的市场总览组合试算
  MARKET_INDEX_Logged = '/dashboard/index',
  MARKET_PACKAGE_ASSEMBLY_Logged = '/dashboard/packageAssembly',
  MARKET_DRO_DETAIL_Logged = '/dashboard/droDetail',

  // 系统通知
  SYS_NOTIFICATION = '/sysNotification',
  // 列表
  SYS_NOTIFICATION_LIST = '/sysNotification/list',
}
export const RegisterRoutes = [
  PageEnum.ACCOUNT_AGREEMENT,
  PageEnum.ACCOUNT_REGISTER,
  PageEnum.INDIVIDUAL_PI,
  PageEnum.INDIVIDUAL_PI_APPLY,
  PageEnum.CORPORATE_PI,
  PageEnum.INSTITUTION_PI,
  PageEnum.INSTITUTION_PI_APPLY,
  PageEnum.USER_INFO,
];
/**
 * package枚举
 */
export const PackageEnum = {
  dmp: 'dmp',
};
